export default __webpack_public_path__ + "static/media/math.56ea8800.png";